module.exports = __webpack_public_path__ + "img/fo.99655988.svg";